// JSON-API request builder from ember-data doesn't implement fields yet.
// I created an util to reproduce it until it hits the production.
// https://github.com/emberjs/data/blob/main/packages/json-api/src/-private/builders/-utils.ts
export default function requestWithFields(
  request: { url: string },
  fields: Record<string, string[] | string>
): void {
  const fieldsQueryParam: string[] = [];
  const keys = Object.keys(fields).sort();
  for (let i = 0; i < keys.length; i++) {
    const resourceType = keys[i];
    const value = fields[resourceType];

    if (Array.isArray(value)) {
      fieldsQueryParam.push(
        `fields[${encodeURIComponent(resourceType)}]=${value.sort().map(encodeURIComponent).join(",")}`
      );
    } else {
      fieldsQueryParam.push(
        `fields[${encodeURIComponent(resourceType)}]=${value.split(",").sort().map(encodeURIComponent).join(",")}`
      );
    }
  }

  if (fieldsQueryParam.length > 0) {
    const separator = request.url.includes("?") ? "&" : "?";
    request.url = `${request.url}${separator}${fieldsQueryParam.join("&")}`;
  }
}
